export function build(data) {
    return {
        id: data.id.toString(),
        position: data.position,
        comment: data.comment,
        user: data.user,
        links: data.links,
        editable: !!(data.links && data.links.update),
        deletable: !!(data.links && data.links.destroy),
        state: {
            editing: false,
            deleting: false,
        },
        form: {
            comment: '',
        },
    };
}
